import React from 'react';
import { Box, Card, CardContent, Typography, Divider } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

// Payment status only ever changes via the PayU notify webhook — this page
// is informational only, no manual "I've paid" action.
const BankTransferStep = ({ orderId, totalAmount }) => {
    const bankAccount = '12 3456 7890 1234 5678 9012 3456';
    const intl = useIntl();
    const title = intl.formatMessage({ id: 'bank_transfer_order_title' }, { id: orderId });

    return (
        <Box sx={{ textAlign: 'center', mt: 6 }}>
            <Card sx={{ maxWidth: 480, mx: 'auto' }}>
                <CardContent sx={{ py: 4 }}>
                    <Typography variant="h5" gutterBottom>
                        <FormattedMessage id="bank_transfer_heading" />
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                        <FormattedMessage id="bank_transfer_intro" />
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Box sx={{ textAlign: 'left', display: 'grid', rowGap: 1.5 }}>
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                <FormattedMessage id="bank_transfer_account" />
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {bankAccount}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                <FormattedMessage id="bank_transfer_amount" />
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {totalAmount.toFixed(2)} zł
                            </Typography>
                        </Box>
                        <Box>
                            <Typography variant="caption" color="text.secondary">
                                <FormattedMessage id="bank_transfer_title" />
                            </Typography>
                            <Typography variant="body1" fontWeight={600}>
                                {title}
                            </Typography>
                        </Box>
                    </Box>

                    <Divider sx={{ my: 3 }} />

                    <Typography variant="body2" color="text.secondary">
                        <FormattedMessage id="bank_transfer_pending" />
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

export default BankTransferStep;
